import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import VersionHistoryTable from '../../../_shared/_components/VersionHistoryTable';

const VersionHistory: React.FC = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const templateId = id ? Number(id) : 0;

  const handleVersionClick = (versionNumber: number) => {
    navigate(`../../view/${templateId}?versionNumber=${versionNumber}`);
  };

  return (
    <VersionHistoryTable
      templateId={templateId}
      onVersionClick={handleVersionClick}
    />
  );
};

export default VersionHistory;

